export const IZS = 'IZS';
export const MKD = 'MKD';

export type ACCOUNTING_TYPES = (typeof IZS | typeof MKD)[];

export const ACCOUNTING_TYPE: Record<typeof IZS | typeof MKD, string> = {
  IZS: 'ИЖС',
  MKD: 'МКД',
};
